import {
	fixedFilter,
	getCookie,
	initComponents,
	initSavingCollapseById,
	isMobile,
	move,
	moveEnd,
	openPtx,
	openWithParams,
	reloadContentAll,
	selectIfOnlyOne,
	setCookie
} from "./main_ptx";
import {defaultJsonCallback, placeResponse} from "./main_callbacks";
import {resizeToBottomCorner} from "./main";
import {submit} from "./main_form";
import {initTableHeader, initTables} from "./main_tables";


export const mainSel = '.main-content';
export const contentSel = '#page-content';
export const filterSel = '#page-filter';

/** find first page from given url link
 * @alias Ptx.page.findPageFromSection
 * @param link - MUST end with /_
 * return true if found, otherwise returns link itself
 */
export function findPageFromSection(link) {
	var SECTION = '/\_';

	if (link.endsWith(SECTION)) {
		var parseLink = link.split("/");
		var sectionIndex = 2; //assume we run in app contex /positrex, but we wanna be in ROOT ....
		if ((Ptx.baseUrl == "") || (parseLink[1] != Ptx.baseUrl.substring(1))) {
			sectionIndex = 1;
		}
		
		var ctx = $('#menu-' + parseLink[sectionIndex]);
		
		var start = link.replace(SECTION, '');
		var first = $('li a[href^="' + start + '"][href$=".htm"]', ctx).first();
		if (first) {
			location.hash = first.attr('href');
			return true;
		}
	}
	return link;
}

/**
 * open page from hash location,
 * @alias Ptx.page.open
 * @param hash - including # at the beginning
 */
export function openPage(hash) {
	if (hash) {
		var loadHash = findPageFromSection(hash);

		if (loadHash == true) {
			return;
		}
		var url = loadHash.substring(1);
    	unloadCommon();
		Ptx.ajax = openWithParams(url, "GET", {}, placeResponse);
	}
}

/**
 * @alias Ptx.page.initFilter
 * @param ctx where to init
 */
export function initFilter(ctx){
	move('#filter', '#page-filter');

	$('.loading-bar').click(function () {
		Ptx.showLoading(true, "export", null);
		setTimeout(function () {
			Ptx.showLoading(false, 'export', null);
		}, 9000);
	});
	
	//* P - causes submit of page filter on change
	$('.ptx-filter-auto-submit', ctx).on('change', function(e) {
		e.preventDefault();
		filter($(this));
	});

	//* P - causes submit of page filter on click
	$('.ptx-filter-submit', ctx).on('click', function(e) {
		e.preventDefault();
		filter($(this));
	});

	$('#ptx-filter-close', ctx).on('click', function(e) {
		e.preventDefault();
		$("#page-filter").removeClass('active');
		$("#panel-menu-overlay").removeClass('active');
	});
	
	$('.ptx-send-with-filter', ctx).on('click', function(e) {
		e.preventDefault();
		sendWithFilter($(this));
	});
	
	//* P - causes submit of page form on click
	$('.ptx-page-form-submit', ctx).on('click', function(e) {
		e.preventDefault();
		var form = $(this).closest('form');
	    var msg = $(this).data('confirm-msg');
		form.find('.ptx-page-form-submit').prop('disabled', true);
	    if (msg) {
	    	Ptx.confirm(msg, function (ok) {
	        	if (ok) {
	          		submit(form, defaultJsonCallback);
	        	}
	      	});
	    } else {
	      	submit(form, defaultJsonCallback);
	    }
	});

    initTableHeader($('#content').not('.notHeader'))
	
	$('form', ctx).submit(function() {
		var $form = $(this);
		if ($form.find('.ptx-filter-submit').length > 0) { //there is a submit button , then filter
			filter($(this));
		} else if ($form.find('.ptx-filter-auto-submit').length > 0) { //is some auto-filtering item here?
			filter($(this));
		} else if ($form.find('.ptx-standard-form-submit').length > 0) {
			// There is some specific situations where we want to allow standard (with working rendering of possible errors from validator back to page)
			// form submitting not only from modal dialogs but also from form on page itself.
			return true;
		}
	    return false;//prevent default submission.
	});
	
	if (isMobile()) {
		moveEnd('#ptx-filter-send-btn', '#ptx-filter-form');
	}

	selectIfOnlyOne($('#filterUnitId'));
}

/**
 * Wrapped into this function because call of await loadMessages(); function inside initCommon(ctx) function
 * leads to malfunction of jQuery "datatables.net" library with error message:
 * "Cannot set properties of undefined (setting '_DT_CellIndex')"
 * while calling of function $this.DataTable(tableSettings); inside initTables(ctx) function!
 * @returns {Promise<void>}
 */
export async function initMessages() {
	await loadMessages();
}

/**
 * init common parts in page
 * @alias Ptx.page.initCommon
 * @param ctx - page context
 */
export function initCommon(ctx) {

	initTables(ctx);

	initSavingCollapseById('filter-detail', location.href, function () {
		resizeToBottomCorner('.scroller-content', 'height');
	});

	var searchBox = $('#searched');
	searchBox.doneTyping(function () {
		var t = $(this).val();
		Ptx.tables.defaultSearch = t;
		openPtx('/user/searched.json', 'POST', {searched: t}, function (data, svr) {
			//TODO neco?
		}, {showLoader: false});
	});

	//* P - pagination select, submit page filter with page={data-page-number}
	$('.ptx-pagination-select', ctx).on('change', function (e) {
		var pageNumber = $(this).val();
		e.preventDefault();
		getFilter('.ptx-pagination-form').each(function () {
			var form = $(this);
			$('input[name="pageNumber"]', form).val(pageNumber);
			form.trigger('submit');
		});

	});

	//* P - pagination links, submit page filter with page={data-page-number}
	$('.ptx-pagination-call', ctx).on('click', function (e) {
		var pageNumber = $(this).data('page-number');
		e.preventDefault();
		getFilter('.ptx-pagination-form').each(function () {
			var form = $(this);
			$('input[name="pageNumber"]', form).val(pageNumber);
			form.trigger('submit');
		});
	});

	initComponents(ctx);
	reloadContentAll('#ptx-menu');

	try {
		var s = localStorage.getItem('switch-appearance');

		if (s != null) {
			$('#switch-reseller-appearance').prop('checked', (s == 'true'));
		}
	} catch (e) {
		console.log('Unable to restore admin info: ' + e);
	}
}

/**
 * Blocking loading (return from function after AJAX call that loading messages was finished) of default frequently used messages into session storage.<br>
 * <b>WARNING: To work properly must be called in async function this way: "await loadMessages();" !!!</b><br>
 * Loads commonly used messages into session storage for fast access to them and
 * not to be loaded again and again from database at any load or reload of page.
 * Uses non-public (login is required) url to load messages, so applied only on non-public pages.
 * @returns {Promise<void>}
 */
async function loadMessages() {
	const loadMessages = sessionStorage.getItem("loadMessagesDoneTime") == null;
	const loggedIn = $('#logoutForm').length !== 0;
	if (loadMessages && loggedIn) {
		// Un-comment it for debug of async behaviour of loading messages into session storage.
		// console.log(new Date().toISOString() + " | Loading messages...");
		openWithParams(Ptx.url('/user/resolver/i18n-default-messages.json'), 'GET', null,
			function(data) {
				for (var i = 0; i < data.length; i++) {
					const tuple = data[i];
					Ptx.setMsg(tuple.k, tuple.m);
				}
				// Un-comment it for debug of async behaviour of loading messages into session storage.
				// console.log(new Date().toISOString() + " | " + data.length + " messages loaded");
				sessionStorage.setItem("loadMessagesDoneTime", new Date().getTime() + '');
			},{showLoader: false}
		);
	} else {
		return; // Messages was already loaded in session storage.
	}

	const startTime = new Date().getTime();
	while(sessionStorage.getItem("loadMessagesDoneTime") == null) {
		await wait(100);
		const timeWaited = new Date().getTime() - startTime;
		if (timeWaited > 3000) {
			console.warn(new Date().toISOString() + " | Messages wasn't loaded in timeout!");
			break;
		}
	}
}

/**
 * Blocking waiting.<br>
 * <b>WARNING: To work properly must be called in async function this way: "await wait(1000);" !!!</b><br>
 * Inspired by: https://stackoverflow.com/questions/951021/what-is-the-javascript-version-of-sleep
 * 			and https://stackoverflow.com/questions/14220321/how-to-return-the-response-from-an-asynchronous-call
 * @param millis {number} milliseconds to wait
 * @returns {Promise<unknown>}
 */
function wait(millis) {
	return new Promise(r => setTimeout(r, millis));
}

/**
 * called on page unload (refresh, or navigation to somewhere else
 * @alias Ptx.page.unloadCommon
 */
export function unloadCommon() {
    if (Ptx.page.ctx) {
    	
    	if (typeof Ptx.refresh !== 'undefined') {
            clearTimeout(Ptx.refresh)
        }
    	
    	if (typeof Ptx.page.ctx.refresh !== 'undefined') {
            clearInterval(Ptx.page.ctx.refresh)
        }
    	
        if (Ptx.page.ctx.onunload) {
            Ptx.page.ctx.onunload();
        }
        delete Ptx.page.ctx;
    }
    Ptx.page.ctx = {};
    Ptx.page.ctx.onloadComponents = [];
}

/**
 * refresh current page
 * @alias Ptx.page.reloadCurrent
 * @param doNotFilter - optional, if true, then hard refresh, NO FILTER!!!
 */
export function reloadCurrent(doNotFilter) {
	Ptx.allDataLoaded = false;
	if (typeof doNotFilter === "undefined") {
		doNotFilter = false;
	}
	if (doNotFilter) {
		openPage(location.hash);
	} else {
		var filterForm = getFilter('form');

		if (filterForm.length && filterForm.length > 0) {
			//if pagination is present, fill it!
			var page = $('.ptx-pagination-current-page').data('page-number');
			$('input[name="pageNumber"]').val(page);
			filterForm.trigger('submit');
		}
	}
}

/**
 * find selector in filter section of page
 * @alias Ptx.page.getFilter
 * @param selector - what to find in page form
 */
export function getFilter(selector) {
	var filterForm = $(selector, filterSel);
	
	if (filterForm.length == 0) {// fallback for sitemeshed pages
		filterForm = $(selector, 'div#ptx-filter');
	}
	return filterForm;
}

/**
 * open url, and changes location in browser url bar
 * @alias Ptx.page.openUrl
 * @param urlWithoutHash
 */
export function openUrl(urlWithoutHash) {
	window.location = urlWithoutHash;
}

/**
 * Send request with settings from ptx-filter-form
 * Use in case you can set options (from, to, ...) without post page by normal search
 * @alias Ptx.page.sendWithFilter
 */
export function sendWithFilter(ele) {
	Ptx.allDataLoaded = false;
	var $form = $('#ptx-filter-form');
	var url = ele.attr('href');
	var data = $form.serialize();
	
	if (ele.is('input:submit') || ele.is('input:button')) {//submit via button, add its value to request as well
		data += '&' + encodeURI(ele.attr('name'))+'='+ encodeURI(ele.attr('value'))
	}
	data += '&sm_dec=none'; //no decorator
	
	if (ele.data("send-ajax")) { //when controller returns JsonDlgView
		openWithParams(url, 'GET', data);
	} else { // Use for download
		openUrl(url + "?"+ data);
	}
}

/**
 * perform filtering on page, open url specified in filter form element and POST data to it
 * Form can have data attributes - data-ptx-loader-selector and data-ptx-loader-action to specify what to do when page is submitted via filter
 * @alias Ptx.page.filter
 * @param ele - element in form
 */
export function filter(ele) {
	Ptx.allDataLoaded = false;
	var $form = ele.closest('form');
	var method = $form.attr('method');
	var url = $form.attr('action');
	var data = $form.serialize();
	//* P - on ptx-filter-auto-submit element specify if do hard reload of page with all stuff (CSS)
	var forceReload = ele.hasClass('ptx-force-reload'); //after change reload hard , not only ajax - use carefully
	var requestOptions = {forceReload:forceReload};

	requestOptions['loader'] = "#loader";
	requestOptions['locationName'] = "filter";

	if (ele.is('input:submit') || ele.is('input:button')) {//submit via button, add its value to request as well
		data += '&' + encodeURI(ele.attr('name'))+'='+ encodeURI(ele.attr('value'))
	}
	data += '&sm_dec=none'; //no decorator
	
  	unloadCommon();
  	Ptx.ajax = openWithParams(url, method, data, placeResponse, requestOptions);
}